import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as result from '../result'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: result.RESOURCE.payload.dimension.partialId,
      partialId: result.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'When the latest test run finished; null until CI finishes.',
    isOptional: true,
    name: 'Tested At',
    partialId: PartialId.Standard.create('tested_at'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
